module.exports = __webpack_public_path__ + "img/home.1b212a48.svg";